export default "__VITE_ASSET__jXhxhA6q__"